import { ActionIcon, Menu, UnstyledButton, rem } from '@mantine/core';

import { IconDots } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

const MenuButtonItem = ({ text, onClick }) => {
    return (
        <Menu.Item
            component={UnstyledButton}
            onClick={onClick}>
            {text}
        </Menu.Item>
    );
};

const MenuLinkItem = ({ text, path }) => {
    return (
        <Menu.Item
            component={NavLink}
            to={path}>
            {text}
        </Menu.Item>
    );
};

const ActionsColumn = ({
    row: { original: rowData },
    openDetailsModal,
    setModalItem,
    setTab,
}) => {
    const dropdownOptions = [
        {
            text: 'Events',
            onClick: () => {
                setModalItem(rowData);
                setTab('events');
                openDetailsModal();
            },
        },
    ];
    return (
        <Menu disabled={false}>
            <Menu.Target>
                <ActionIcon
                    color={'dimmed'}
                    variant='transparent'
                    disabled={false}>
                    <IconDots stroke={1.5} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {dropdownOptions.map((x, i) =>
                    x.path ? (
                        <MenuLinkItem
                            key={i}
                            {...x}
                        />
                    ) : (
                        <MenuButtonItem
                            key={i}
                            {...x}
                        />
                    )
                )}
            </Menu.Dropdown>
        </Menu>
    );
};
export default ActionsColumn;
